import { render, staticRenderFns } from "./CreateOrderDashboard.vue?vue&type=template&id=cd983934"
import script from "./CreateOrderDashboard.vue?vue&type=script&lang=js"
export * from "./CreateOrderDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports